<div class="policies-section ps-d-flex ps-justify-content-center ps-pr-4 ps-pl-2">
  <div purpleEditableText tranKey='terms_and_conditions' [innerHtml]="'terms_and_conditions' | translation: 'TODO': []" class="policies-container ps-w-100">
  </div>
</div>